module.exports = __webpack_public_path__ + "static/media/kirigaya-suguha-icon.2186d110.png";